
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.722 41.564a5.638 5.638 0 015.638-5.638h2.28a5.638 5.638 0 015.638 5.638V54H24.722V41.564z","fill":"#3DAFB8"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M8.907 29.903c0-1.921.816-3.752 2.244-5.038l15.815-14.233a6.778 6.778 0 019.068 0L51.85 24.865a6.778 6.778 0 012.244 5.038v17.315a6.778 6.778 0 01-6.778 6.778h-31.63a6.778 6.778 0 01-6.778-6.778V29.903z","stroke":"#fff","stroke-width":"2.4"}})])
          )
        }
      }
    